import React from 'react';
import FormRest from "v4/components/form/FormRender/components/FormRest/FormRest";
import FieldWrapper from "v4/components/form/FieldWrapper/FieldWrapper";
import FormRow from "v4/components/form/FormRender/components/FormRow/FormRow";
import {useFormRenderContext} from "v4/components/form/FormRender/context/FormRenderContext";
import {useWatch} from "react-hook-form";

export default function CustomEventTriggersFormRender() {
    const {formRenderMethods} = useFormRenderContext();

    const [
        typeValue,
        aConditionValue,
    ] = useWatch({
        name: ['type', 'aCondition'],
        control: formRenderMethods.control,
        defaultValue: ['', ''],
    });

    return (
        <>
            <FormRest except={['value', 'specificFieldId', 'containValues']}/>

            <FormRow fieldName="specificFieldId" isUnregistered={typeValue !== 'specific_field_tasks'}/>

            <FormRow fieldName="containValues" isUnregistered={aConditionValue !== 'condition_contains_tasks'}/>

            <FormRow fieldName="value"
                     fieldRender={(field) => {
                         field.attr = {
                             ...(field.attr ?? {}),
                             style: {minHeight: '100px'},
                         };

                         return (
                             <FieldWrapper field={field}
                                           name={field.name}
                                           className="col-md-12 mb-4"/>
                         )
                     }}/>
        </>
    )
}
